import type { NskResponse } from "~/models/Api";
import type { DealVendorCompany } from "~/models/DealVendorCompany";
import { postRequest, putRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/vendors/deals/:deal_id/deal_vendor_companies",
	update: "/vendors/deals/:deal_id/deal_vendor_companies/:id"
};

export const create = async (
	dealId: number,
	vendorCompanyId: number
): Promise<NskResponse> =>
	postRequest(paths.create.replace(":deal_id", String(dealId)), {
		vendorCompanyId
	});

export const update = async (
	dealId: number,
	dealVendorCompany: DealVendorCompany,
	vendorUserId: number | null,
	noteWithinVendor: string | null
): Promise<NskResponse> =>
	putRequest(
		paths.update.replace(
			":deal_id",
			String(dealId).replace(":id", String(dealVendorCompany.id))
		),
		{
			noteWithinVendor,
			vendorUserId
		}
	);
